import { MassMessageSendingMethods } from 'models';

function isDisabledSendingMethod(
  availableSendingMethods: number[],
  checkedSendingMethod: MassMessageSendingMethods
) {
  return !availableSendingMethods.includes(checkedSendingMethod);
}

export function curryIsDisabledSendingMethod(
  availableSendingMethods: number[]
) {
  return (checkedSendingMethod: MassMessageSendingMethods) =>
    isDisabledSendingMethod(availableSendingMethods, checkedSendingMethod);
}

export function stringCharCount(input: string) {
  let gsm7bitChars =
    '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
  let gsm7bitExChar = '^{}\\[~]|€';

  let gsm7bitUnits = 0;

  for (let i = 0, len = input.length; i < len; i++) {
    if (gsm7bitUnits != null) {
      if (gsm7bitChars.indexOf(input.charAt(i)) > -1) {
        gsm7bitUnits++;
      } else if (gsm7bitExChar.indexOf(input.charAt(i)) > -1) {
        gsm7bitUnits += 2;
      } else {
        gsm7bitUnits = 0;
      }
    }
  }
  return gsm7bitUnits;
}
